<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <q-card
      flat
      bordered
      class="q-dialog-plugin"
    >
      <q-toolbar
        dense
        color="primary"
      >
        <q-avatar>
          <q-icon
            name="mdi-arrow-collapse"
            color="green"
            size="md"
            class="q-pa-none"
          />
        </q-avatar>

        <q-toolbar-title>
          <span>Transferência</span>
        </q-toolbar-title>

        <q-btn
          flat
          round
          dense
          icon="mdi-close"
          v-close-popup
        />
      </q-toolbar>

      <q-separator inset />

      <q-card-section>
        <div v-html="bodyMessage" />
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn
          flat
          no-caps
          padding="5px 12px"
          color="primary"
          @click="onCancelClick"
        >
          Cancelar
        </q-btn>

        <q-btn
          no-caps
          padding="5px 12px"
          color="primary"
          @click="onOKClick"
        >
          Transferir!
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { VOICE_CHANNEL } from '@/constants/channels'
import { entryNumberType } from '@/libs/transferUtils'

export default {
  props: {
    call: {},
    entryNumber: {}
  },

  computed: {
    ...mapState({
      ongoingCalls: ({ attendanceModule }) => {
        const calls = Object.values(attendanceModule.current)
        return calls.filter(({ channel }) => channel === VOICE_CHANNEL)
      }
    }),

    bodyMessage () {
      const { destinationType, description, number } = this.entryNumber ?? {}
      if (destinationType === 'URA') return `Confirma a transferência do atendimento para <b>URA</b><br><b>${description}</b>?<br><i>${number}</i>`
      if (destinationType === 'QUEUE') return `Confirma a transferência do atendimento para <b>Fila</b><br><b>${description}</b>?<br><i>${number}</i>`
      if (destinationType === 'AGENT') return `Confirma a transferência do atendimento para o <b>Agente</b><br><b>${description}</b>?<br><i>${number}</i>`
      if (destinationType === 'EXTENSION') return `Confirma a transferência do atendimento para o <b>Ramal</b><br><b>${description}</b>?<br><i>${number}</i>`
      if (destinationType === 'AGENTCODE') return `Confirma a transferência do atendimento para o <b>Agente</b><br><b>${description}</b>?<br><i>${number}</i>`
      return `Confirma a transferência do atendimento para o <b>número<b> <b>${number}</b>?`
    },

    number () {
      const { number } = this.entryNumber ?? {}
      return number ?? ''
    },

    description () {
      const { description } = this.entryNumber ?? {}
      return description ?? ''
    },

    numberType () {
      return entryNumberType(this.entryNumber)
    }
  },

  methods: {
    show () {
      this.$refs.dialog.show()
    },

    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      this.$emit('hide')
    },

    onOKClick () {
      this.$emit('ok')
      this.hide()
    },

    onCancelClick () {
      this.hide()
    }
  },

  watch: {
    ongoingCalls (ongoingCalls) {
      if (!ongoingCalls.length) this.onCancelClick()
      const isOngoingCall = ongoingCalls.find((ongoingCall) => ongoingCall?.id === this.call.id)
      if (!isOngoingCall) this.onCancelClick()
    }
  }
}
</script>
